import { Component } from '@angular/core';

@Component({
  selector: 'app-bank-configuration',
  templateUrl: './bank-configuration.component.html',
  styleUrls: ['./bank-configuration.component.scss']
})
export class BankConfigurationComponent {

}
